import { theme } from 'antd';

export const useTheme = () => {
  const { token } = theme.useToken();
  
  // Get the theme name from the CSS variable
  const getThemeName = () => {
    const root = document.documentElement;
    const appName = getComputedStyle(root).getPropertyValue('--ant-appName').trim();
    return appName.toLowerCase();
  };

  return {
    themeName: getThemeName(),
  };
}; 